import { ChangeDetectionStrategy, Component } from '@angular/core';
import { AppPermission } from '@app/shared/services/apps/apps.service';

@Component({
  standalone: false,
  selector: 'sbnb-hudson-creative-studio',
  templateUrl: './hudson-creative.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class HudsonCreativeStudioComponent {
  AppPermission = AppPermission;
}
